/**
 * The live scene.
 *
 * Backdrop is the transition's own end frame, so the handoff matches by construction.
 * When that plate is unavailable the scene falls back to the token-driven void — the
 * application still boots and the full journey still runs. No placeholder artwork is
 * ever invented (ENG-069); absence is expressed with tokens, not with a stand-in image.
 */
import { assetUrl, assetExists } from '../core/assets';

export async function mountScene(root: HTMLElement): Promise<{ hasPlate: boolean }> {
  const scene = document.createElement('div');
  scene.className = 'cc-scene';
  root.append(scene);

  const hasPlate = await assetExists('startup_endframe');
  if (hasPlate) {
    scene.style.backgroundImage = `url(${assetUrl('startup_endframe')})`;
    scene.dataset['source'] = 'plate';
  } else {
    scene.dataset['source'] = 'void';
  }
  return { hasPlate };
}
